import React, { useMemo } from 'react'
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles'
import { deepmerge } from '@mui/utils'
import { bhyveNavFont } from './bhyveNavFont'

/**
 * Applies Inter (Figma) to MUI typography inside BHYVE chrome only — page content in `<main>` stays on the app theme.
 */
export const BhyveNavChromeThemeProvider: React.FC<{
  children: React.ReactNode

  /** When set, the wrapper fills the flex parent (primary rail) so nested `height: 100%` scroll regions work. */
  fullHeight?: boolean
}> = ({ children, fullHeight = false }) => {
  const theme = useTheme()
  const chromeTheme = useMemo(
    () =>
      createTheme(
        deepmerge(theme, {
          typography: {
            fontFamily: [bhyveNavFont.style.fontFamily, 'Roboto', 'Helvetica Neue', 'Arial', 'sans-serif'].join(',')
          }
        })
      ),
    [theme]
  )

  return (
    <ThemeProvider theme={chromeTheme}>
      <div
        className={bhyveNavFont.className}
        style={
          fullHeight
            ? {
                flex: 1,
                minHeight: 0,
                height: '100%',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden'
              }
            : undefined
        }
      >
        {children}
      </div>
    </ThemeProvider>
  )
}
